import React, { useState } from "react";
import { notifyError, notifySuccess } from "../../utils/notify";


export function RegisterUserForm({ onSubmit }) {
  // Keep track of form data in local state
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    password: "",
    confirm_password: "",
  });

  // Handle changes to form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.first_name) {
      notifyError("First name is required");
      return;
    }
    if (!formData.last_name) {
      notifyError("Last name is required");
      return;
    }
    if (!formData.email) {
      notifyError("Email is required");
      return;
    }
    if (!formData.username) {
      notifyError("Username is required");
      return;
    }
    if (!formData.password) {
      notifyError("Password is required");
      return;
    }
    if (formData.password !== formData.confirm_password) {
      notifyError("Passwords do not match");
      return;
    }

    // Call the parent onSubmit function with the form data
    onSubmit(formData);
  };

  return (
    <div className="pt-6">
      <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
        <div className="flex justify-start">
          <button
            type="submit"
            className="bg-yellow-500 text-white px-4 py-2 rounded-lg"
          >
            Register
          </button>
        </div>

        {/* First Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            First Name
          </label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Last Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Last Name
          </label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Username */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Username
          </label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            autoComplete="off"
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Password
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            autoComplete="off"
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Confirm Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Confirm Password
          </label>
          <input
            type="password"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>
      </form>
    </div>
  );
}
